import React from 'react';

import ObligationsTypeComponents from '../../../../../components/ObligationsTypeComponents';
import formatDollars from '../../../../../helpers/format/formatDollars';
import ObligationStatus from './Components/ObligationStatus';
import formatDate from '../../../../../helpers/format/formatDate';
import { Button, Grid, IconButton } from '@material-ui/core';
import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import colors from "../../../../../theme/colors";
import isEmpty from 'lodash/isEmpty';

interface IParties {
    type: string;
    user: string;
    company: string;
    account: string;
    role: string;
}
const columns = (runFailedLedgerWalletObligationHandler: any, handleResubmitButton: Function) => [
    {
        key: ['type', 'description'],
        name: 'Type',
        format: (type: string, description: string): JSX.Element => (
            <ObligationsTypeComponents type={type} description={description} />
        ),
    },
    {
        key: ['status', 'id', 'type', 'status_note'],
        name: 'Status',
        format: (status: string, id: string, type: string, status_note: string): JSX.Element => {
            return (
                <div>
                    <ObligationStatus status={status_note || status} style={{ fontSize: 16 }} />
                    {(type === 'LEDGER_WALLET_WITHDRAWAL' && status_note === 'Insufficient Funds') &&
                        <IconButton onClick={() => runFailedLedgerWalletObligationHandler(id)}>
                            <FontAwesomeIcon icon={faRetweet} color={colors.green} />
                        </IconButton>
                    }
                </div>
        )},
    },
    {
        key: ['from_party', 'to_party'],
        name: 'From → To',
        format: (from_party: IParties, to_party: IParties): JSX.Element =>
        (!isEmpty(from_party) && !isEmpty(to_party)) ? <div>
            <p>{from_party.role} → {to_party.role}</p>
        </div> : <div />

    },
    {
        key: 'payments_due_date',
        name: 'Due Date',
        format: formatDate,
    },
    {
        key: ['amount', 'status'],
        name: 'Amount',
        format: (amount: number, status: string): JSX.Element => (
            <>
                {!status.includes('RECEIVABLE') ? (
                    <p>{formatDollars(amount)}</p>
                ) : (
                    <div />
                )}
            </>
        ),
    },
    {
        key: ['can_resubmit', 'id'],
        format: (can_resubmit: string, id: string): JSX.Element => (
            <Grid>
                {can_resubmit &&
                    <Button
                        variant="raised"
                        size="medium"
                        color="primary"
                        onClick={() => handleResubmitButton(id)}
                    >
                        Resubmit
                    </Button>
                }
            </Grid>
        )
    }
];

export default columns;
